export default __webpack_public_path__ + "images/984f59e7ca3fc5375921f6d1d38665c5.png";